import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import ResultModal from "../Common/ResultModal";
import SpinnerLoading from "../../Components/Common/SpinnerLoading";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import { languageServices } from "../../Services";
import Tooltip from "../Common/Tooltip";
import { lettersOnly } from "../../Config/Regex";
import { set } from "date-fns";
import AddResourcesModal from "./AddResourcesModal";

const EditLanguage = ({ match }) => {
  const languageId = match.params.languageId;
  const history = useHistory();
  const { t: translator } = useTranslation();
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { updateTranslation,isMobile } = useContext(GlobalContext);

  const [isLanguageLoading, setIsLanguageLoading] = useState(true);
  const [showNewResourceModal, setShowNewResourceModal] = useState(false);
  const [isTranslationsLoading, setIsTranslationsLoading] = useState(true);

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const [selectedLanguage, setSelectedLanguage] = useState();
  const [resources, setResources] = useState();
  const [filteredResources, setFilteredResources] = useState();
  const [filters, setFilters] = useState({
    key: "",
    value: "",
  });

  React.useEffect(() => {
    if (![master, admin, support].includes(Number(roleId)))
      history.push("/error-page/401");
    else {
      if (languageId) {
        languageServices.getById(languageId).then((data) => {
          setSelectedLanguage(data.data);
          setIsLanguageLoading(false);
        });

        languageServices.getTranslations(languageId).then((data) => {
          setResources(data.data.data);
          setFilteredResources(data.data.data);
          setIsTranslationsLoading(false);
        });
      }
    }
  }, [languageId]);

  React.useEffect(() => {
    if (resources) {
      setFilteredResources(
        resources.filter(
          (x) =>
            x.key.toUpperCase().indexOf(filters.key.toUpperCase()) > -1 &&
            x.value.toUpperCase().indexOf(filters.value.toUpperCase()) > -1
        )
      );
    }
  }, [resources, filters, pagination]);

  // React.useEffect(() => {
  //   setPagination({
  //     ...pagination,
  //     pageIndex: 0,
  //     totalCount: filteredResources && filteredResources.length,
  //   });
  // }, [filteredResources]);

  // React.useEffect(() => {
  //   console.log("pagination", pagination);
  // }, [pagination]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
    setPagination({
      ...pagination,
      pageIndex: 0,
      totalCount: filteredResources && filteredResources.length,
    });
  };

  const handleCancel = () => {
    history.push("/language");
  };

  const goBack = () => {
    history.push("/language");
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    if (resultModal.success === true) {
      goBack();
    }
  };

  const onSubmit = (data) => {
    if (languageId) {
      languageServices
        .update({
          languageId: languageId,
          name: data.name,
          shortName: data.shortName,
          cultureCode: data.cultureCode,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditLanguage-SuccessModal-Title"),
                text: translator("EditLanguage-SuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditLanguage-UnsuccessModal-Title"),
                text: translator("EditLanguage-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditLanguage-UnsuccessModal-Title"),
            text: translator("EditLanguage-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    }
  };

  const columns = [
    {
      dataField: "id",
      text: "Resource Id",
      hidden: true,
    },
    {
      dataField: "key",
      text: translator("EditLangugae-TableHeader-Key"),
      editable: false,
    },
    {
      dataField: "value",
      text: translator("EditLanguage-TableHeader-Value"),
    },
  ];

  return (
    <>
      <div className="p-2">
        <div className="card container-fluid p-0">
          <div className="card-header card-wrap">
            <span>
              {(languageId &&
                translator("EditLanguage-Span-LanguageEditing")) ||
                translator("EditLanguage-Span-NewLanguage")}
 {languageId &&
                <button
            className={
              "btn btn-primary float-right " + (isMobile ? "btn-sm" : "")
            }
            onClick={()=>setShowNewResourceModal(true)}
          >
            <span
              className="icon icon-cancel web-hidden"
              style={{ transform: "rotate(45deg)" }}
            ></span>{" "}
            <span className="mob-hidden">
              {translator("Language-AddNewTranslation")}
            </span>
          </button>}
            </span>
          </div>
          <div className="row card-body">
            <div className="col col-lg-3 col-md-4 col-xs-12">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditLanguage-LegendMainData")}
                </legend>
                {isLanguageLoading && <SpinnerLoading />}
                {!isLanguageLoading && (
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label>{translator("EditLanguage-Name")}</label>{" "}
                      <Tooltip text={translator("Language-Name-Msg")} />
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        ref={register({
                          required: true,
                          pattern: lettersOnly,
                          maxLength: 20,
                        })}
                        defaultValue={selectedLanguage && selectedLanguage.name}
                        onChange={handleInputChange}
                      />
                      {errors.name && errors.name.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                      {errors.name && errors.name.type === "pattern" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-LettersOnly")}
                        </p>
                      )}
                      {errors.name && errors.name.type === "maxLength" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-MaxLength20")}
                        </p>
                      )}
                    </div>

                    <div className="form-group">
                      <label>{translator("EditLanguage-Code")}</label>{" "}
                      <Tooltip text={translator("Language-Code-Msg")} />
                      <input
                        type="text"
                        className="form-control"
                        name="shortName"
                        ref={register({
                          required: true,
                          pattern: lettersOnly,
                          maxLength: 3,
                        })}
                        defaultValue={
                          selectedLanguage && selectedLanguage.shortName
                        }
                        onChange={handleInputChange}
                      />
                      {errors.shortName &&
                        errors.shortName.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      {errors.shortName &&
                        errors.shortName.type === "pattern" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-LettersOnly")}
                          </p>
                        )}
                      {errors.shortName &&
                        errors.shortName.type === "maxLength" && (
                          <p className="text-danger">
                            {translator(
                              "ValidationMsg-MaxLength-ThreeCharacters"
                            )}
                          </p>
                        )}
                    </div>

                    <div className="form-group">
                      <label>{translator("EditLanguage-CultureCode")}</label>{" "}
                      <Tooltip text={translator("Language-CultureCode-Msg")} />
                      <input
                        type="text"
                        className="form-control"
                        name="cultureCode"
                        ref={register({ required: true, maxLength: 10 })}
                        defaultValue={
                          selectedLanguage && selectedLanguage.cultureCode
                        }
                        onChange={handleInputChange}
                      />
                      {errors.cultureCode &&
                        errors.cultureCode.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      {errors.cultureCode &&
                        errors.cultureCode.type === "maxLength" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-MaxLength10")}
                          </p>
                        )}
                    </div>

                    <div
                      className="form-group"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        className="btn btn-outline-secondary"
                        onClick={handleCancel}
                      >
                        {translator("Btn-Cancel")}
                      </button>
                      &nbsp;
                      <button className="btn btn-primary" type="submit">
                        {translator("Btn-Save")}
                      </button>
                    </div>
                  </form>
                )}
              </fieldset>

              <ResultModal
                show={resultModal.show}
                title={resultModal.title}
                text={resultModal.text}
                btnClass={resultModal.btnClass}
                handleClose={handleCloseResultModal}
              />

              <AddResourcesModal
                languageId={languageId}
                show={showNewResourceModal}
                handleHide={() => {
                 
                  setShowNewResourceModal(false);
                }}
              />
            </div>
            <div className="col col-lg-8 col-md-6 col-xs-12">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditLanguage-Translations")}
                </legend>
                <form className="row">
                  <div className="form-group col-sm-12 col-lg-6">
                    <label>{translator("EditLanguage-Key")}</label>
                    <input
                      name="key"
                      type="text"
                      className="form-control"
                      defaultValue={filters.key}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group col-sm-12 col-lg-6">
                    <label>{translator("EditLanguage-Translation")}</label>
                    <input
                      name="value"
                      type="text"
                      className="form-control"
                      defaultValue={filters.value}
                      onChange={handleInputChange}
                    />
                  </div>
                </form>
                {isTranslationsLoading && <SpinnerLoading />}
                {!isTranslationsLoading &&
                  (!filteredResources || filteredResources.length === 0) &&
                  translator("NoData")}
                {!isTranslationsLoading &&
                  filteredResources &&
                  filteredResources.length > 0 && (
                    <BootstrapTable
                      keyField="id"
                      data={filteredResources}
                      columns={columns}
                      pagination={paginationFactory({
                        page: pagination.pageIndex + 1,
                        sizePerPage: pagination.pageSize,
                        totalSize: pagination.totalCount,
                      })}
                      cellEdit={cellEditFactory({
                        mode: "click",
                        blurToSave: true,
                        beforeSaveCell: (oldValue, newValue, row, column) => {
                          languageServices
                            .updateTranslation({
                              languageId: languageId,
                              resourceId: row.id,
                              value: newValue,
                            })
                            .then(() =>
                              updateTranslation({
                                languageId: languageId,
                                key: row.key,
                                value: newValue,
                              })
                            );
                        },
                      })}
                    />
                  )}
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditLanguage;
